import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { SourceBuilder } from '../../models/builders/source.builder';
import { Print } from '../../models/print';
import { Source } from '../../models/source';

const sourceBody = (source: Source) => ({
  name: source.name,
  active: source.active
});

@Injectable()
export class SourceApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }sources`;
  }

  getSourcesByPrint(print: Print) {
    const params = new HttpParams()
    .append('print', print.hash);

    return this.httpClient.get(`${ this.apiUrl }/by-print`, { params })
      .pipe(
        map(SourceBuilder.fromList)
      );
  }

  createSource(source) {
    return this.httpClient.post(this.apiUrl, sourceBody(source)).pipe(map(SourceBuilder.fromJson));
  }

  deleteSource(source: Source) {
    return this.httpClient.delete(`${ this.apiUrl }/${ source.hash }`);
  }

  getSources() {
    return this.httpClient.get(`${ this.apiUrl }`).pipe(map(SourceBuilder.fromList));
  }

  getSource(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`).pipe(map(SourceBuilder.fromJson));
  }

  updateSource(source: Source) {
    return this.httpClient.put(`${ this.apiUrl }/${ source.hash }`, sourceBody(source));
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/source-api.service.ts